import React from 'react';
import Papa from 'papaparse';
import Select from 'react-select';

class AutoComplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      inputValue: props.initialInputValue ? props.initialInputValue : props.isMultiple ? [] : '',
      searchString: ''
    };
  }

  componentDidMount() {
    fetch(this.props.csvRoute)
      .then((response) => response.text())
      .then((data) => {
        const parsedData = this.parseCSV(data);

        const results = parsedData
          .filter((option) => option[this.props.dataLabel]) // Filter out options with null or empty names
          .map((option) => ({
            value: option[this.props.dataLabel],
            label: option[this.props.dataLabel]
          }));

        this.setState({ data: results });
      })
      .catch((error) => console.error('Error fetching the CSV file:', error));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.initialInputValue !== this.props.initialInputValue) {
      this.setState({
        inputValue: this.props.initialInputValue
          ? this.props.initialInputValue
          : this.props.isMultiple
            ? []
            : ''
      });
    }
  }

  parseCSV(data) {
    const results = Papa.parse(data, { header: true });
    return results.data;
  }

  getOptionList() {
    const { searchString, data } = this.state;
    if (searchString.length >= this.props.minSearchLength) {
      if (Array.isArray(searchString)) {
        return data
          .filter((option) =>
            searchString.some((value) => option.label.toLowerCase().includes(value.toLowerCase()))
          )
          .slice(0, 15);
      } else {
        return data
          .filter((option) => option.label.toLowerCase().includes(searchString.toLowerCase()))
          .slice(0, 15);
      }
    }
    return [];
  }

  handleInputChange = (searchString) => {
    this.setState({
      searchString: searchString
    });
  };

  handleChange = (selectedOption) => {
    if (this.props.isMultiple) {
      const selectedValues = selectedOption ? selectedOption.map((option) => option.label) : [];
      this.setState({ inputValue: selectedValues });
      if (this.props.onOptionSelect) {
        this.props.onOptionSelect(selectedValues);
      }
    } else {
      const selectedValue = selectedOption ? selectedOption.label : '';
      this.setState({ inputValue: selectedValue });
      if (this.props.onOptionSelect) {
        this.props.onOptionSelect(selectedValue);
      }
    }
  };

  noOptionsMessage = () => {
    return this.state.searchString.length < this.props.minSearchLength
      ? `Type ${this.props.minSearchLength} characters to search`
      : 'No options';
  };

  render() {
    const customStyles = {
      container: (provided) => ({
        ...provided,
        flex: '1 1' // Apply flex to the main container
      }),
      control: (provided) => ({
        ...provided,
        borderTopLeftRadius: 0, // Apply border radius styles to the control element
        borderBottomLeftRadius: 0
      })
    };

    return (
      <div className="input-group input-group-sm mb-3">
        <br />
        <div className="input-group-prepend">
          <span
            className="input-group-text"
            id="inputGroup-sizing-sm"
            style={{ borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px' }}
          >
            {this.props.inputLabel}
          </span>
        </div>
        <Select
          isMulti={this.props.isMultiple}
          options={this.getOptionList()}
          onChange={this.handleChange}
          onInputChange={this.handleInputChange}
          placeholder="Select an option..."
          noOptionsMessage={this.noOptionsMessage}
          isClearable
          styles={customStyles}
          value={
            this.state.inputValue.length == 0
              ? null
              : this.props.isMultiple
                ? this.state.inputValue.map((value) => ({ label: value, value: value }))
                : { label: this.state.inputValue, value: this.state.inputValue }
          }
        />
      </div>
    );
  }
}

export default AutoComplete;
